import { render, staticRenderFns } from "./DSInput.vue?vue&type=template&id=a583a61c&scoped=true&"
import script from "./DSInput.vue?vue&type=script&lang=js&"
export * from "./DSInput.vue?vue&type=script&lang=js&"
import style0 from "./DSInput.vue?vue&type=style&index=0&id=a583a61c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a583a61c",
  null
  
)

export default component.exports